const apiFields = {
  EntradaEmOperacao: {
    label: 'asset-information.asset-info.operation-entry',
    key: 'operationEntry',
  },
  Descricao: {
    label: 'asset-information.asset-info.asset-description',
    key: 'description',
  },
  NumeroSerie: {
    label: 'asset-information.asset-info.serial-number',
    key: 'serialNumber',
  },
  CodigoInstalacao: {
    label: 'asset-information.asset-info.installation-code',
    key: 'installationCode',
  },
  CodigoOperacional: {
    label: 'asset-information.asset-info.operational-code',
    key: 'operationCode',
  },
  PosicaoOperativa: {
    label: 'asset-information.asset-info.operative-position',
    key: 'operativePosition',
  },
  Fabricante: {
    label: 'asset-information.asset-info.manufacturer',
    key: 'manufacturer',
  },
  Modelo: {
    label: 'asset-information.asset-info.model',
    key: 'model',
  },
  Ano: {
    label: 'asset-information.asset-info.manufacturing-year',
    key: 'year',
  },
  Observacoes: {
    label: 'fields.general.observations',
    key: 'observation',
  },
  Identificacao: {
    label: 'asset-information.asset-info.asset-identification',
    key: 'identification',
  },
  NomePersonalizado: {
    label: 'asset-information.asset-info.asset-identification',
    key: 'identification',
    precision: 1,
  },
};

export function getApiFieldsByKey(key) {
  const filteredEntries = Object.entries(apiFields).filter(entry => entry[1].key === key);
  return Object.fromEntries(filteredEntries);
}

export default apiFields;
